import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Collapse,
} from "reactstrap"
import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const Announcement = () => {
  // ---------------------Collapse Start-------------------------
  const [faq1, setFaq1] = useState(false)
  // ---------------------Collapse End-------------------------

  const [Announcement_Modal, setAnnouncement_Modal] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function AddAnnouncement_Modal() {
    setAnnouncement_Modal(!Announcement_Modal)
    removeBodyCss()
  }

  const [selectedGroup, setselectedGroup] = useState(null)
  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
    },
  ]

  const [totalSize, setTotalSize] = useState(3)

  const data = {
    columns: [
      {
        text: "Announcement Title",
        dataField: "AnnouncementTitle",
        style: { width: "25%" },
      },
      {
        text: "Announcement",
        dataField: "Announcement",
        style: { width: "36%" },
      },
      {
        text: "Start Date",
        dataField: "StartDate",
        style: { width: "13%" },
      },
      {
        text: "End Date",
        dataField: "EndDate",
        style: { width: "13%" },
      },
      {
        text: "Status",
        dataField: "Status",
        style: { width: "13%" },
      },
    ],
    rows: [
      {
        AnnouncementTitle: "Nilesh",
        Announcement: "Soni",
        StartDate: "20-Sep-2022",
        EndDate: "28-Sep-2022",
        EmailId: "info@nilesh.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-lightionStatust btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddAnnouncement_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        AnnouncementTitle: "Nilesh",
        Announcement: "Soni",
        StartDate: "20-Sep-2022",
        EndDate: "28-Sep-2022",
        EmailId: "info@nilesh.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-lightionStatust btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddAnnouncement_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        AnnouncementTitle: "Nilesh",
        Announcement: "Soni",
        StartDate: "20-Sep-2022",
        EndDate: "28-Sep-2022",
        EmailId: "info@nilesh.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-lightionStatust btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddAnnouncement_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Announcement List | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Utility"
              breadcrumbItem="Announcement List"
            />
            <Col sm={6}>
              <div className="float-end d-none d-md-block pt-2">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  onClick={() => {
                    AddAnnouncement_Modal()
                  }}
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  Add Announcement
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="accordion mb-3" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button font-size-15 faq"
                      style={{
                        backgroundColor: "rgb(164, 229, 207)",
                        height: "40px",
                        color: "#000",
                      }}
                      type="button"
                      onClick={() => {
                        setFaq1(!faq1)
                      }}
                    >
                      <i class="fas fa-filter"></i> &nbsp;Filter Announcement
                      List
                    </button>
                  </div>
                  <Collapse isOpen={faq1} className="accordion-collapse">
                    <div className="accordion-body">
                      <Row>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Announcement Title</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="AnnouncementTitle"
                              id="AnnouncementTitle"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Start Date</Label>
                            <Input
                              type="date"
                              maxLength="25"
                              name="StartDate"
                              id="StartDate"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>End Date</Label>
                            <Input
                              type="date"
                              maxLength="25"
                              name="EndDate"
                              id="EndDate"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              value={selectedGroup}
                              onChange={() => {
                                handleSelectGroup()
                              }}
                              options={optionGroup}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col lg="12">
                          <div className="float-end d-none d-md-block pt-0">
                            <Button
                              color="primary"
                              className="btn btn-primary waves-effect waves-light mt-0"
                            >
                              Search
                            </Button>{" "}
                            <Button
                              color=""
                              className="btn btn-outline-primary mt-0"
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable responsive bordered data={data} noBottomColumns/> */}
                  <CustomTable
                    keyField="candidateList"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        size="md"
        isOpen={Announcement_Modal}
        toggle={() => {
          AddAnnouncement_Modal()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Announcement
          </h5>
          <button
            onClick={() => {
              AddAnnouncement_Modal()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="AnnouncementTitle"
                    label="Announcement Title"
                    placeholder="Announcement Title"
                    type="text"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField type="select" name="Status" label="Status">
                    <option>Active</option>
                    <option>Inactive</option>
                  </AvField>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="Start Date"
                    name="StartDate"
                    type="date"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="End Date"
                    name="EndDate"
                    type="date"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="12">
                <FormGroup className="mb-3">
                  <AvField
                    name="Announcement"
                    label="Announcement"
                    placeholder="Announcement..."
                    type="textarea"
                    className="form-control"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Button color="primary" className="mt-3" type="submit">
              Submit
            </Button>{" "}
            <Button
              color="outline-primary"
              className="mt-3"
              onClick={() => {
                AddAnnouncement_Modal()
              }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </Button>
          </AvForm>
        </div>
      </Modal>
    </React.Fragment>
  )
}
